export enum RebillyOrderType {
  OneTime = 'one-time-order',
  Subscription = 'subscription-order',
}
